/**
 * 批量修改用户状态
 */
import React from 'react';
import {Button, Radio} from "antd";
import CmModal from "../../../../components/CmModal/CmModal";
import {message} from "../../../../view/sysManagement/utils/sysManagementUtils";
import BaseComponent from "../../../../base/BaseComponent";

export default class BatchUpdateUserStatus extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            batchUpdateUserStatusVisible: false,
            tsUserList: props.tsUserList,
            status: 1
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tsUserList: nextProps.tsUserList
        })
    }

    batchUpdateHandle = () => {
        const {tsUserList} = this.state;
        if (!tsUserList.length) {
            message.warn('请选择用户！');
            return false
        }
        if (tsUserList.length) {
            this.setState({
                batchUpdateUserStatusVisible: true,
                status: 1
            });
        }
    };

    handleCancel = () => {
        this.setState({
            batchUpdateUserStatusVisible: false
        });
    };

    /**
     * 批量修改用户类型
     */
    batchUpdate = () => {
        if (!this.state.status) {
            message.warn("请选择用户状态！");
            return;
        }
        let ids = [];
        let {tsUserList} = this.state;
        tsUserList.forEach(function (item) {
            ids.push(item.id);
        });
        let params = {
            ids,
            status: this.state.status
        }
        this.request({
            url: "/cm-sites-mmp/rmUser/batchUpdate",
            body: params,
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if (res) {
                    message.success("用户修改状态成功");
                    this.props.refreshList();
                    this.handleCancel();
                }
            }
        });
    };

    render() {
        const options = [
            {
                key: "1",
                value: 1,
                title: "启用"
            },
            {
                key: "2",
                value: 2,
                title: "禁用"
            }
        ];
        return (
            <>
                <Button style={{marginRight: "20px"}} onClick={this.batchUpdateHandle}>
                    批量修改用户状态
                </Button>
                {/*批量修改用户状态弹窗*/}
                <CmModal
                    handleOk={this.batchUpdate}
                    handleCancel={this.handleCancel}
                    visible={this.state.batchUpdateUserStatusVisible}
                    title="批量修改用户状态"
                    width={500}
                >
                    <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <div style={{marginRight: "20px"}}><span style={{color: "red"}}>*</span>用户状态：</div>
                        <div>
                            <Radio.Group
                                style={{lineHeight: "37px"}}
                                value={this.state.status}
                                onChange={(e) => {
                                    this.setState({
                                        status: e.target.value
                                    })
                                }}>
                                {options.length > 0 && options.map(i => {
                                    return <Radio key={i.key} value={i.value}>{i.title}</Radio>
                                })}
                            </Radio.Group>
                        </div>
                    </div>
                </CmModal>
            </>
        )
    }
}